class GIconArrowRight extends HTMLElement {
  connectedCallback() {
    this.innerHTML = '<svg class="g-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.2 18.1"><path d="M11.2 9l-9.1 9.1L0 16l6.9-7L0 2.1 2.1 0l9.1 9z"/></svg>';
  }
}

if (!customElements.get('g-icon-arrow-right')) {
  customElements.define('g-icon-arrow-right', GIconArrowRight);
}
